import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./header and footer/Footer";
import "./css/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChalkboardUser,
  faHandshake,
  faUserPlus,
  faBookOpen,
  faLightbulb,
  faArrowRight,
  faRocket
} from "@fortawesome/free-solid-svg-icons";

function GetStarted() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
    );
    document.querySelectorAll(".reveal, .reveal-stagger").forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const pathways = [
    {
      icon: faChalkboardUser,
      title: "Become an Instructor",
      desc: "Share your expertise with thousands of learners worldwide. Apply to join our team of professional instructors and create impactful courses in your field of expertise.",
      link: "/register?tab=instructor",
      btnText: "Apply Now",
      color: "#0284c7"
    },
    {
      icon: faHandshake,
      title: "Become a Partner",
      desc: "Collaborate with Consortium eLearning to bring transformative digital education to your organization. We offer customized training solutions for corporates and institutions.",
      link: "/register?tab=partner",
      btnText: "Partner With Us",
      color: "#059669"
    },
    {
      icon: faUserPlus,
      title: "Become a Member",
      desc: "Create your free student account to access our complete course catalog, earn certificates, participate in discussions, and track your learning progress across all devices.",
      link: "/register?tab=student",
      btnText: "Register Free",
      color: "#2563eb"
    },
    {
      icon: faBookOpen,
      title: "Register a Course",
      desc: "Browse through 500+ expert-led courses across multiple disciplines. Find the perfect course to match your career goals, skill level, and learning preferences.",
      link: "/courses",
      btnText: "Browse Courses",
      color: "#0891b2"
    },
    {
      icon: faLightbulb,
      title: "Learn a New Skill",
      desc: "Whether you want to code, design, manage, or lead — start building in-demand skills today with interactive video lectures, hands-on projects, and verifiable certificates.",
      link: "/courses",
      btnText: "Start Learning",
      color: "#4f46e5"
    }
  ];

  return (
    <div>
      <Navbar page={"get-started"} />

      <div className="page-banner" style={{ paddingBottom: "40px" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", color: "#bae6fd", padding: "8px 20px", borderRadius: "30px", fontSize: "0.85rem", fontWeight: 600, marginBottom: "20px" }}>
          <FontAwesomeIcon icon={faRocket} /> Let's Start Your Journey
        </div>
        <h1>Choose Your Path</h1>
        <p>Whether you want to learn, teach, or partner — there's a place for you at Consortium eLearning.</p>
      </div>

      <section style={{ padding: "80px 8%" }}>
        <div className="pathway-grid reveal-stagger">
          {pathways.map((p, i) => (
            <div key={i} className="pathway-card">
              <div className="pathway-icon" style={{ background: `${p.color}15`, color: p.color }}>
                <FontAwesomeIcon icon={p.icon} />
              </div>
              <h3>{p.title}</h3>
              <p>{p.desc}</p>
              <Link to={p.link} className="pathway-btn" style={{ background: `linear-gradient(135deg, ${p.color}, ${p.color}dd)` }}>
                {p.btnText} <FontAwesomeIcon icon={faArrowRight} />
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* Info Banner */}
      <section style={{
        padding: "60px 8%", background: "var(--gradient-hero)",
        textAlign: "center"
      }}>
        <div className="reveal">
          <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: "2rem", fontWeight: 800, color: "#fff", marginBottom: "12px" }}>
            Not Sure Where to Start?
          </h2>
          <p style={{ color: "#94a3b8", fontSize: "1.05rem", maxWidth: "600px", margin: "0 auto 28px" }}>
            Contact our team for personalized guidance on choosing the right learning path for your goals and experience level.
          </p>
          <Link to="/contact" style={{
            display: "inline-flex", alignItems: "center", gap: "8px", background: "#fff",
            color: "#2563eb", padding: "14px 32px", borderRadius: "12px", fontWeight: 700,
            fontSize: "0.95rem", textDecoration: "none", boxShadow: "0 10px 30px rgba(0,0,0,0.2)"
          }}>
            Contact Our Team <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default GetStarted;
